import { requestApi } from "../axios";

export function getConfig(partnerAppId) {
  return requestApi(`/admin/cx/config-output?partnerAppId=${partnerAppId}`, "GET");
}

export function createConfig(data, file) {
  if (file) {
    const formData = new FormData();
    formData.append("partnerAppId", data.partnerAppId);
    formData.append("name", data.name);
    formData.append("key", data.key);
    formData.append("value", data.value);
    formData.append("file", file);
    return requestApi(`/admin/cx/config-output`, "POST", formData, {
      "Content-Type": "multipart/form-data",
    });
  }
  return requestApi(`/admin/cx/config-output`, "POST", data);
}

export function handleFileCertificate(data) {
  return requestApi(`/admin/cx/handle-file-certificate-from-firebase`, "POST", data);
}
